// extracted by mini-css-extract-plugin
export default {"buttonForgot":"ButtonBack_buttonForgot__-1lh+"};